document.addEventListener('DOMContentLoaded', function() {
  // Select all the different toggle types
  var toggles = document.querySelectorAll('.menu__toggle, .alternativ_toggle'); // Added alternativ_toggle here
  var subToggles = document.querySelectorAll('.menu__sub-toggle:not(.alternativ_toggle)'); // Exclude alternativ_toggle
  var grandchildToggles = document.querySelectorAll('.menu__grandchild-toggle');
  var greatGrandchildToggles = document.querySelectorAll('.menu__great-grandchild__sub-toggle');
  
  // Check if an alternativ_menu item is active and open corresponding main toggle
  var alternativeMenuActive = document.querySelector('.menu__sub-toggle.menu__sub-toggle--opened');
  if (alternativeMenuActive) {
    // Find parent .menu__toggle element
    var parentToggle = alternativeMenuActive.closest('.menu__toggle-content')?.closest('.menu__toggle');
    if (parentToggle) {
      parentToggle.classList.add('menu__toggle--opened');
    }
  }
  
  // Find active great-grandchild menu items
  var activeGreatGrandchildItems = document.querySelectorAll('.menu__great-grandchild__sub-toggle--opened');
  activeGreatGrandchildItems.forEach(function(item) {
    // Open parent grandchild-toggle
    var parentGrandchildToggle = item.closest('.menu__grandchild-toggle');
    if (parentGrandchildToggle) {
      parentGrandchildToggle.classList.add('menu__grandchild-toggle--opened');
      
      // Open parent sub-toggle
      var parentSubToggle = parentGrandchildToggle.closest('.menu__sub-toggle');
      if (parentSubToggle) {
        parentSubToggle.classList.add('menu__sub-toggle--opened');
        
        // Open parent toggle
        var parentToggle = parentSubToggle.closest('.menu__toggle-content')?.closest('.menu__toggle');
        if (parentToggle) {
          parentToggle.classList.add('menu__toggle--opened');
        }
      }
    }
  });
  
  // Add event listeners to main toggles and alternativ_toggle
  toggles.forEach(function(toggle) {
    var title;
    if (toggle.classList.contains('alternativ_toggle')) {
      title = toggle.querySelector('.menu__sub-toggle-title');
    } else {
      title = toggle.querySelector('.menu__toggle-title');
    }
    
    if (title) {
      title.addEventListener('click', function() {
        var isOpened;
        if (toggle.classList.contains('alternativ_toggle')) {
          isOpened = toggle.classList.contains('menu__sub-toggle--opened');
        } else {
          isOpened = toggle.classList.contains('menu__toggle--opened');
        }
        
        // Close all toggles
        toggles.forEach(function(item) {
          if (item !== toggle) {
            if (item.classList.contains('alternativ_toggle')) {
              item.classList.remove('menu__sub-toggle--opened');
            } else {
              item.classList.remove('menu__toggle--opened');
            }
          }
        });
        
        // Toggle current item
        if (!isOpened) {
          if (toggle.classList.contains('alternativ_toggle')) {
            toggle.classList.add('menu__sub-toggle--opened');
          } else {
            toggle.classList.add('menu__toggle--opened');
          }
        } else {
          if (toggle.classList.contains('alternativ_toggle')) {
            toggle.classList.remove('menu__sub-toggle--opened');
          } else {
            toggle.classList.remove('menu__toggle--opened');
          }
        }
      });
    }
  });
  
  // Add event listeners to sub-toggles (excluding alternativ_toggle)
  subToggles.forEach(function(subToggle) {
    var subTitle = subToggle.querySelector('.menu__sub-toggle-title');
    if (subTitle) {
      subTitle.addEventListener('click', function() {
        var isSubOpened = subToggle.classList.contains('menu__sub-toggle--opened');
        subToggles.forEach(function(item) {
          if (item !== subToggle) {
            item.classList.remove('menu__sub-toggle--opened');
          }
        });
        if (!isSubOpened) {
          subToggle.classList.add('menu__sub-toggle--opened');
        } else {
          subToggle.classList.remove('menu__sub-toggle--opened');
        }
      });
    }
  });
  
  function handleToggle(elements, className) {
    elements.forEach(function(element) {
      var title = element.querySelector(':scope > *[tabindex="0"]');
      if (title) {
        title.addEventListener('click', function() {
          var isOpened = element.classList.contains(className);
          elements.forEach(function(item) {
            if (item !== element) {
              item.classList.remove(className);
            }
          });
          if (!isOpened) {
            element.classList.add(className);
          } else {
            element.classList.remove(className);
          }
        });
      }
    });
  }
  
  handleToggle(grandchildToggles, 'menu__grandchild-toggle--opened');
  handleToggle(greatGrandchildToggles, 'menu__great-grandchild__sub-toggle--opened');
});


document.addEventListener('DOMContentLoaded', function() {
  // Elemente selektieren
  const mobileMenuButton = document.querySelector('.products-toolbar__menu_mobile');
  const facetsDrawer = document.querySelector('.facets.drawer');
  const overlay = document.querySelector('.overlay');
  const closeButton = document.querySelector('.js-close-drawer');
  
  // Event-Listener für das Öffnen der Seitenleiste
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', function() {
      if (facetsDrawer) {
        facetsDrawer.setAttribute('open', '');
      }
      if (overlay) {
        overlay.classList.add('is-visible');
      }
    });
  }
  
  // Event-Listener für das Schließen der Seitenleiste
  const closeDrawer = function() {
    if (facetsDrawer) {
      facetsDrawer.removeAttribute('open');
    }
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  };
  
  // Event-Listener für den Overlay
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }
  
  // Event-Listener für den Schließen-Button
  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }
});

(function() {
  const productReturnKey = 'handpraesent:alternative-menu-return';
  const productRestoreKey = 'handpraesent:alternative-menu-restore';
  const menuContextKey = 'handpraesent:collection-menu-context';
  const menuReturnKey = 'handpraesent:collection-menu-parent-return';
  const menuHistoryTargetKey = 'handpraesentCollectionMenuParentTarget';
  const menuHistoryGuardKey = 'handpraesentCollectionMenuGuard';
  const maxAge = 30 * 60 * 1000;

  function readSessionValue(key) {
    try {
      const value = JSON.parse(sessionStorage.getItem(key));
      if (!value || Date.now() - value.timestamp > maxAge) {
        sessionStorage.removeItem(key);
        return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function writeSessionValue(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function removeSessionValue(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function getSameOriginUrl(url) {
    try {
      const target = new URL(url, window.location.origin);
      return target.origin === window.location.origin ? target : null;
    } catch (error) {
      return null;
    }
  }

  function hasSamePath(firstUrl, secondUrl) {
    const first = getSameOriginUrl(firstUrl);
    const second = getSameOriginUrl(secondUrl);
    return Boolean(first && second && first.pathname === second.pathname);
  }

  function isSameLocation(url) {
    const target = getSameOriginUrl(url);
    if (!target) return false;
    return target.pathname === window.location.pathname
      && target.search === window.location.search
      && target.hash === window.location.hash;
  }

  function setToggleState(element, openClass, titleSelector, open) {
    if (!element) return;
    element.classList.toggle(openClass, open);
    const title = element.querySelector(titleSelector);
    if (title) title.setAttribute('aria-expanded', String(open));
  }

  function closeMenuBranches(sidebar) {
    sidebar.querySelectorAll('.menu__toggle').forEach(function(element) {
      setToggleState(element, 'menu__toggle--opened', ':scope > .menu__toggle-title', false);
    });
    sidebar.querySelectorAll('.menu__sub-toggle').forEach(function(element) {
      setToggleState(element, 'menu__sub-toggle--opened', ':scope > .menu__sub-toggle-title', false);
    });
    sidebar.querySelectorAll('.menu__grandchild-toggle').forEach(function(element) {
      setToggleState(element, 'menu__grandchild-toggle--opened', ':scope > .menu__grandchild-toggle-title', false);
    });
    sidebar.querySelectorAll('.menu__great-grandchild__sub-toggle').forEach(function(element) {
      setToggleState(element, 'menu__great-grandchild__sub-toggle--opened', ':scope > .menu__great-grandchild__sub-toggle-title', false);
    });
    sidebar.querySelectorAll('.link--active').forEach(function(element) {
      element.classList.remove('link--active');
    });
    sidebar.querySelectorAll('.menu__list-item--active').forEach(function(element) {
      element.classList.remove('menu__list-item--active');
    });
  }

  function openMenuBranch(menuLink) {
    setToggleState(menuLink.closest('.menu__toggle'), 'menu__toggle--opened', ':scope > .menu__toggle-title', true);
    setToggleState(menuLink.closest('.menu__sub-toggle:not(.alternativ_toggle)'), 'menu__sub-toggle--opened', ':scope > .menu__sub-toggle-title', true);
    setToggleState(menuLink.closest('.alternativ_toggle'), 'menu__sub-toggle--opened', ':scope > .menu__sub-toggle-title', true);
    setToggleState(menuLink.closest('.menu__grandchild-toggle'), 'menu__grandchild-toggle--opened', ':scope > .menu__grandchild-toggle-title', true);
    setToggleState(menuLink.closest('.menu__great-grandchild__sub-toggle'), 'menu__great-grandchild__sub-toggle--opened', ':scope > .menu__great-grandchild__sub-toggle-title', true);
  }

  function findContextLink(sidebar, context) {
    return Array.from(sidebar.querySelectorAll('a[data-menu-source]')).find(function(menuLink) {
      return menuLink.dataset.menuSource === context.source
        && hasSamePath(menuLink.href, context.selectedUrl)
        && hasSamePath(menuLink.dataset.menuRootUrl, context.rootUrl)
        && hasSamePath(menuLink.dataset.menuBranchUrl, context.branchUrl);
    });
  }

  function applyMenuContext() {
    const context = readSessionValue(menuContextKey);
    const sidebar = document.querySelector('.sidebar-main__menu');
    if (!context || !sidebar || !hasSamePath(context.selectedUrl, window.location.href)) return;

    const menuLink = findContextLink(sidebar, context);
    if (!menuLink) return;

    closeMenuBranches(sidebar);
    menuLink.classList.add('link--active');
    const listItem = menuLink.closest('.menu__list-item');
    if (listItem) listItem.classList.add('menu__list-item--active');
    openMenuBranch(menuLink);
  }

  function storeMenuContext(menuLink) {
    const destinationUrl = getSameOriginUrl(menuLink.href);
    const rootUrl = getSameOriginUrl(menuLink.dataset.menuRootUrl);
    const branchUrl = getSameOriginUrl(menuLink.dataset.menuBranchUrl);
    const parentUrl = getSameOriginUrl(menuLink.dataset.menuReturnUrl);
    if (!destinationUrl || !rootUrl || !branchUrl) return;

    const context = {
      source: menuLink.dataset.menuSource,
      selectedUrl: destinationUrl.href,
      rootUrl: rootUrl.href,
      branchUrl: branchUrl.href,
      timestamp: Date.now()
    };
    writeSessionValue(menuContextKey, context);

    if (parentUrl && !hasSamePath(parentUrl.href, destinationUrl.href)) {
      writeSessionValue(menuReturnKey, {
        source: context.source,
        destinationUrl: destinationUrl.href,
        parentUrl: parentUrl.href,
        rootUrl: context.rootUrl,
        branchUrl: context.branchUrl,
        timestamp: context.timestamp
      });
    } else {
      removeSessionValue(menuReturnKey);
    }
  }

  function selectParentContext(returnData, parentUrl) {
    writeSessionValue(menuContextKey, {
      source: returnData.source,
      selectedUrl: parentUrl.href,
      rootUrl: returnData.rootUrl,
      branchUrl: returnData.branchUrl,
      timestamp: Date.now()
    });
  }

  function getHistoryState() {
    const state = window.history.state;
    if (!state || typeof state !== 'object' || Array.isArray(state)) return {};
    return Object.assign({}, state);
  }

  function installMenuHistoryGuard() {
    const returnData = readSessionValue(menuReturnKey);
    if (!returnData) return;

    const destinationUrl = getSameOriginUrl(returnData.destinationUrl);
    const parentUrl = getSameOriginUrl(returnData.parentUrl);
    if (!destinationUrl || !parentUrl) {
      removeSessionValue(menuReturnKey);
      return;
    }

    if (!hasSamePath(destinationUrl.href, window.location.href)) return;

    const originalState = window.history.state;
    const currentState = getHistoryState();
    if (currentState[menuHistoryGuardKey]) return;

    const targetState = Object.assign({}, currentState);
    delete targetState[menuHistoryGuardKey];
    targetState[menuHistoryTargetKey] = returnData;

    const guardState = Object.assign({}, currentState);
    delete guardState[menuHistoryTargetKey];
    guardState[menuHistoryGuardKey] = true;

    try {
      window.history.replaceState(targetState, '', parentUrl.href);
      window.history.pushState(guardState, '', destinationUrl.href);
    } catch (error) {
      try {
        window.history.replaceState(originalState, '', destinationUrl.href);
      } catch (restoreError) {
        return;
      }
    }
  }

  window.addEventListener('popstate', function(event) {
    const returnData = event.state?.[menuHistoryTargetKey];
    if (!returnData) return;

    const parentUrl = getSameOriginUrl(returnData.parentUrl);
    if (!parentUrl) {
      removeSessionValue(menuReturnKey);
      return;
    }

    selectParentContext(returnData, parentUrl);
    removeSessionValue(menuReturnKey);

    if (isSameLocation(parentUrl.href)) {
      window.location.reload();
      return;
    }

    window.location.replace(parentUrl.href);
  });

  document.addEventListener('click', function(event) {
    if (event.defaultPrevented || event.button !== 0
      || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey
      || !(event.target instanceof Element)) return;

    const menuLink = event.target.closest('a[data-menu-source]');
    if (menuLink) {
      storeMenuContext(menuLink);
      return;
    }

    const productLink = event.target.closest('a.js-prod-link');
    const activeMenuLink = document.querySelector('.sidebar-main__menu .link--active');
    if (!productLink || !activeMenuLink) return;

    const productUrl = getSameOriginUrl(productLink.href);
    if (!productUrl || !productUrl.pathname.includes('/products/')) return;

    writeSessionValue(productReturnKey, {
      url: window.location.href,
      scrollY: window.scrollY,
      timestamp: Date.now()
    });
  }, true);

  installMenuHistoryGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMenuContext);
  } else {
    applyMenuContext();
  }

  window.addEventListener('pageshow', function(event) {
    applyMenuContext();

    const productRestoreData = readSessionValue(productRestoreKey);
    if (productRestoreData && isSameLocation(productRestoreData.url)) {
      removeSessionValue(productRestoreKey);
      removeSessionValue(productReturnKey);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          window.scrollTo({ top: productRestoreData.scrollY, behavior: 'auto' });
        });
      });
      return;
    }

    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const isBackForward = event.persisted || navigationEntry?.type === 'back_forward';
    const productReturnData = readSessionValue(productReturnKey);

    if (productReturnData) {
      const productReturnUrl = getSameOriginUrl(productReturnData.url);
      if (!productReturnUrl) {
        removeSessionValue(productReturnKey);
      } else if (!isBackForward) {
        removeSessionValue(productReturnKey);
      } else if (isSameLocation(productReturnUrl.href)) {
        removeSessionValue(productReturnKey);
      } else {
        writeSessionValue(productRestoreKey, productReturnData);
        removeSessionValue(productReturnKey);
        window.location.replace(productReturnUrl.href);
        return;
      }
    }

    const menuReturnData = readSessionValue(menuReturnKey);
    if (!menuReturnData) return;

    const destinationUrl = getSameOriginUrl(menuReturnData.destinationUrl);
    const parentUrl = getSameOriginUrl(menuReturnData.parentUrl);
    if (!destinationUrl || !parentUrl) {
      removeSessionValue(menuReturnKey);
      return;
    }

    if (hasSamePath(destinationUrl.href, window.location.href)) {
      applyMenuContext();
      return;
    }

    if (!isBackForward) {
      removeSessionValue(menuReturnKey);
      return;
    }

    selectParentContext(menuReturnData, parentUrl);
    removeSessionValue(menuReturnKey);

    if (hasSamePath(parentUrl.href, window.location.href)) {
      applyMenuContext();
      return;
    }

    window.location.replace(parentUrl.href);
  });
})();
